import React, { FC } from 'react'
import { Progress, ProgressProps } from '@chakra-ui/react'

import { BasicComponentProps } from '../../common/types'

const ProgressBar: FC<BasicComponentProps<ProgressProps>> = ({ ...rest }) => {
  return <Progress {...rest} />
}

export default ProgressBar
